const awards = [
    {
        title: "Runner-Up in Project Showcasing",
        event: "PSTU IT Carnival 2019",
        image: "img/Activity&Award/runnerup.jpg",
    },
    {
        title: "Education Board Scholarship",
        details: ["PSC", "JSC", "SSC"],
    },
    {
        title: "Aungkur scholarship",
        details: ["2019", "2020", "2021"],
    },
    {
        title: "One Bank scholarship",
        details: ["2019", "2020"],
    },
    {
        title: "Grameen Bank Scholarship",
        details: ["2014", "2016", "2019"],
    },
];

export default awards;
